<template>
  <div id="home" class="container">
    <el-row type="flex" justify="center" class="mt-40">
      <el-col :span="18">
        <img src="@/assets/images/logo_sad.png" class="home-logo">
      </el-col>
    </el-row>
    <div v-if="isOutOfService" class="text-center mt-40">
      <h3 class="out-of-service-text">
        {{ $t('general.outOfService') }}
      </h3>
      <h4>
        {{ $t('general.tryLater') }}
      </h4>
      <img src="/img/status/pending.png" class="out-of-service-image" alt="image">
    </div>
    <div v-if="!isOutOfService">
      <div class="main-container mt-30">
        <h1>{{ $t('messages.homeTrack') }}</h1>
      </div>
      <div class="main-title">
        <h3>{{ $t('general.homeTitle') }}</h3>
      </div>
      <el-row class="mt-30">
        <el-form
          id="mainForm"
          :model="phone">
          <input-interface :image="phone.country.image">
            <el-form-item
              prop="country">
              <el-select v-model="phone.country" value-key="code" :placeholder="$t('general.country')">
                <el-option
                  v-for="(_country) in countries"
                  :key="_country.countryCode"
                  :label="_country.country"
                  :value="_country" />
              </el-select>
            </el-form-item>
          </input-interface>
          <input-interface class="mt-30">
            <el-form-item
              prop="phone">
              <el-input
                v-if="isFirefoxBrowser"
                v-model="phone.phone"
                autofocus
                maxlength="10"
                :placeholder="$t('general.phoneNumber')" />
              <el-input
                v-else
                v-model="phone.phone"
                v-mask="'(000) 000-0000'"
                autofocus
                maxlength="14"
                :placeholder="$t('general.phoneNumber')" />
            </el-form-item>
          </input-interface>
        </el-form>
      </el-row>
      <el-button
        :disabled="disabledButton(by.phone)"
        type="primary"
        native-type="submit"
        class="btn-interface btn-floating red mt-60"
        form="mainForm"
        @click.prevent.native="search(by.phone)">
        {{ $t('general.track') }}
      </el-button>
    </div>
    <Footer />
  </div>
</template>
<script>
// Utils
import { mapState } from 'vuex'
import { removeFolio } from '@/utils/cookies'
import { searchByPhone } from '@/api/customer'
import { object, AllInProgress } from '@/utils/status'

// Components
import Footer from '@/components/Footer'
import InputInterface from '@/components/InputInterface'

export default {
  name: 'Home',
  components: {
    Footer,
    InputInterface
  },
  data() {
    return {
      name: '',
      folio: '',
      admin: '',
      phone: {
        phone: '',
        country: {
          code: '+52',
          country: 'México',
          countryCode: 'MX',
          image: '/img/mexico.png'
        }
      },
      by: {
        phone: 1
      },
      countries: [{
        code: '+52',
        country: 'México',
        countryCode: 'MX',
        image: '/img/mexico.png'
      },
      {
        code: '+1',
        country: 'Estados Unidos de América',
        countryCode: 'USA',
        image: '/img/usa.png'
      }],
      business: 'Jelp app',
      footer: true
    }
  },
  computed: {
    ...mapState(['_folio', 'token']),
    finalPhone: function() {
      return this.phone.phone.replace(/\+?\(?\)?[-_ .]?/g, '')
    },
    isFirefoxBrowser() {
      return window.navigator.userAgent.indexOf('Firefox') !== -1
    },
    isOutOfService() {
      return JSON.parse(process.env.VUE_APP_OUT_OF_SERVICE)
    }
  },
  mounted() {
    removeFolio()
  },
  methods: {
    search: async function(type) {
      switch (type) {
        case this.by.phone: {
          const data = {
            phone: this.finalPhone,
            countryCode: this.phone.country.code
          }
          await this.$store.dispatch('GetAuthToken', data).then(() => {
            this.searchByPhone(data)
          }).catch((err) => {
            if (process.env.NODE_ENV === 'development') {
              console.log(err)
            }
          })
          break
        }
      }
    },
    disabledButton(button) {
      let disabled = false
      switch (button) {
        case this.by.phone:
          if (this.finalPhone.length < 10 && this.phone.country !== '') {
            disabled = true
          }
          break
        case this.by.folio:
          if (this.folio.value.length < 7) {
            disabled = true
          }
          break
      }
      return disabled
    },
    async searchByPhone(data) {
      try {
        const detail = await searchByPhone(data)
        if (detail) {
          const detailTask = detail.filter(_task => {
            return (_task.status === object.COMPLETED || AllInProgress.includes(_task.status)) && typeof _task.rate === 'undefined'
          })
          if (Array.isArray(detailTask) && detailTask.length < 1) {
            this.$message({
              message: this.$t('messages.tasksNotFounds'),
              type: 'success'
            })
          } else if (Array.isArray(detailTask) && detailTask.length === 1) {
            this.$router.push({ path: `/folio/${detailTask[0].folio}`, query: { backActive: true }})
          } else {
            this.$store.commit('TASKS', detailTask)
            this.$router.push({ path: '/orders', query: { backActive: true }})
          }
        }
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.log(err)
        }
      }
    }
  }
}
</script>
